import { useState } from 'react';
import PropTypes from 'prop-types';

import CommentPost from '../CommentPost/CommentPost';
import CommentOptions from '../CommentOptions/CommentOptions';

import classes from './AnswerComment.module.css';

const AnswerComment = props => {
  const [editComment, setEditComment] = useState(false);

  const editCommentHandler = () => {
    setEditComment(!editComment);
  };

  return (
    <div className={classes.answerCommentContainer}>
      <CommentOptions
        adminComment={props.answerData.admin === 1 ? true : false}
        idComment={props.answerData.idSubcomment}
        idLesson={props.idLesson}
        subcomment
        showAnswers={props.showAnswers}
        editCommentHandler={editCommentHandler}
      />
      <CommentPost
        commentData={props.answerData}
        subcomment
        idComment={props.answerData.idSubcomment}
        editCommentHandler={editCommentHandler}
        editComment={editComment}
      />
    </div>
  );
};

AnswerComment.propTypes = {
  // eslint-disable-next-line react/require-default-props
  answerData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  showAnswers: PropTypes.func
};

export default AnswerComment;
